import { Crate } from '@perch-labs/shrike';
import styled from 'styled-components';

export const StyledCrate = styled(Crate)`
  font-family: ${props => props.theme.fontFamilies.main.regular};
  line-height: 1.5;
  color: ${props => props.theme.colors.content.primary};
  -webkit-font-smoothing: antialiased;

  ul {
    list-style: disc;

    p {
      margin 10px 0 0;
    }
  }

  ul, ol {
    padding-left: 20px;

    li {
      margin: 0 0 10px;
    }
  }
`;
